"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InputSearch_component_exports = {};
__export(InputSearch_component_exports, {
  InputSearch: () => InputSearch,
  default: () => InputSearch_component_default
});
module.exports = __toCommonJS(InputSearch_component_exports);
var import_react = __toESM(require("react"));
var import_atoms = require("../../atoms");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_react_i18next = require("react-i18next");
var import_InputSearch = require("./InputSearch.styled");
var import_i18n = __toESM(require("../../../i18n"));
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["handleOnKeyDown", "handleOnChange", "handleOnSearch", "closeButtonLabelText", "searchButtonLabelText"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var InputSearch = function InputSearch2(_ref) {
  var _props$placeholder;
  var handleOnKeyDown = _ref.handleOnKeyDown, handleOnChange = _ref.handleOnChange, handleOnSearch = _ref.handleOnSearch, closeButtonLabelText = _ref.closeButtonLabelText, searchButtonLabelText = _ref.searchButtonLabelText, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(props.value), _useState2 = _slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
  var errorMode = !!props.errorText;
  var titleRef = (0, import_react.useRef)(null);
  var inputRef = (0, import_react.useRef)(null);
  var _useState3 = (0, import_react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isEllipsisActive = _useState4[0], setIsEllipsisActive = _useState4[1];
  var _useState5 = (0, import_react.useState)(0), _useState6 = _slicedToArray(_useState5, 2), itemPosition = _useState6[0], setItemPosition = _useState6[1];
  var idPlaceholder = (_props$placeholder = props.placeholder) === null || _props$placeholder === void 0 ? void 0 : _props$placeholder.replace(/\s+/g, "-").toLowerCase();
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var isAriaDisabled = !!props["aria-disabled"];
  (0, import_react.useEffect)(function() {
    var titleElement = titleRef && titleRef.current;
    if (titleElement) {
      var ellipsisStatus = titleElement.offsetWidth < titleElement.scrollWidth;
      setIsEllipsisActive(ellipsisStatus);
    }
  }, []);
  (0, import_react.useEffect)(function() {
    setInputValue(props.value);
  }, [props.value]);
  var getTitle = function getTitle2() {
    if (isEllipsisActive) {
      return /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
        value: props.labelText
      }, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledLabelTitle, {
        darkMode: props.darkMode,
        ref: titleRef
      }, props.labelText));
    }
    return /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledLabelTitle, {
      darkMode: props.darkMode,
      errorMode,
      ref: titleRef
    }, props.labelText);
  };
  var clearInput = function clearInput2(evt) {
    var inputEl = inputRef && inputRef.current;
    if (!inputValue) {
      handleOnChange(evt);
    } else {
      var clearedEvt = _objectSpread(_objectSpread({}, evt.target), {}, {
        target: {
          value: ""
        }
      });
      handleOnChange(clearedEvt);
    }
    setInputValue("");
    inputEl.focus();
  };
  var handleInputOnSearch = function handleInputOnSearch2() {
    if (handleOnSearch != null && !!inputValue) {
      handleOnSearch(inputValue);
    }
  };
  var handleInputOnChange = function handleInputOnChange2(event) {
    if (handleOnChange != null)
      handleOnChange(event);
    setInputValue(event.target.value);
  };
  var handleInputKeyDown = function handleInputKeyDown2(e) {
    if (handleOnKeyDown != null)
      handleOnKeyDown(e);
    if (e.key === "Enter") {
      handleInputOnSearch();
    }
  };
  var getAriaDescribedBy = function getAriaDescribedBy2() {
    var errorId = "".concat(idPlaceholder, "-errorMessage");
    var hintId = "".concat(idPlaceholder, "-hintMessage");
    if (errorMode) {
      return errorId;
    }
    if (props.hintText) {
      return hintId;
    }
    return null;
  };
  var wrapperInputSearch = (0, import_react.useRef)(null);
  (0, import_useOnKeydown.useOnKeydown)(wrapperInputSearch, function(event) {
    var ArrowDown = event.ArrowDown, ArrowUp = event.ArrowUp;
    var searchItems = wrapperInputSearch.current.querySelectorAll("input, button");
    if (ArrowDown) {
      var pos = itemPosition - 1;
      if (itemPosition > 0 && searchItems[pos]) {
        setItemPosition(pos);
        searchItems[pos].focus();
      }
    }
    if (ArrowUp) {
      var _pos = itemPosition + 1;
      if (itemPosition < searchItems.length - 1 && searchItems[_pos]) {
        setItemPosition(_pos);
        searchItems[_pos].focus();
      }
    }
  });
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledInputSearchContainer, {
    customWidth: props.customWidth,
    ref: wrapperInputSearch
  }, props.labelText && getTitle(), /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledInput, {
    ref: inputRef,
    value: inputValue,
    name: props.name,
    "aria-label": props.ariaLabelInputSearchName || props.labelText || t("dp_core_toCapitalFirstLetter_anyKey", {
      value: t("base_action_search")
    }),
    placeholder: props.placeholder,
    type: "search",
    disabled: props.disabled,
    "aria-disabled": isAriaDisabled,
    withDisabledStyles: props.disabled || isAriaDisabled,
    readOnly: isAriaDisabled,
    labelText: props.labelText,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: handleInputOnChange,
    onKeyDown: handleInputKeyDown,
    errorMode,
    darkMode: props.darkMode,
    "aria-describedby": getAriaDescribedBy(),
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    autoComplete: props.autocomplete
  }), inputValue && /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
    value: closeButtonLabelText || t("base_action_clearSearchInput"),
    aria: {
      expanded: false
    }
  }, !(props.disabled || isAriaDisabled) && /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledCloseButton, {
    onClick: clearInput,
    icon: "x",
    variant: "ghost",
    iconSize: 24,
    disabled: props.disabled,
    darkMode: props.darkMode,
    errorMode,
    ariaLabel: closeButtonLabelText || t("base_action_clearSearchInput"),
    "data-testid": "Clear search input",
    id: "".concat(props.name ? "".concat(props.name, "-") : "", "close-button")
  })), /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
    value: searchButtonLabelText || t("dp_core_toCapitalFirstLetter_anyKey", {
      value: t("base_action_search")
    }),
    ariaHidden: true,
    aria: {
      expanded: false
    }
  }, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledInputSearchButton, {
    onClick: handleInputOnSearch,
    darkMode: props.darkMode,
    errorMode,
    disabled: props.disabled,
    withDisabledStyles: props.disabled || isAriaDisabled,
    "aria-disabled": isAriaDisabled,
    id: "".concat(props.name ? "".concat(props.name, "-") : "", "search-button"),
    variant: "ghost",
    icon: "search",
    "aria-label": searchButtonLabelText || t("dp_core_toCapitalFirstLetter_anyKey", {
      value: t("base_action_search")
    }),
    iconSize: 20
  }))), errorMode && /* @__PURE__ */ import_react.default.createElement("div", {
    role: "alert"
  }, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledHintMessage, {
    darkMode: props.darkMode,
    errorMode: true
  }, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledErrorIcon, {
    icon: "warning",
    darkMode: props.darkMode
  }), /* @__PURE__ */ import_react.default.createElement("span", {
    id: "".concat(idPlaceholder, "-errorMessage")
  }, props.errorText))), props.hintText && !errorMode && /* @__PURE__ */ import_react.default.createElement("div", null, /* @__PURE__ */ import_react.default.createElement(import_InputSearch.StyledHintMessage, {
    darkMode: props.darkMode,
    id: "".concat(idPlaceholder, "-hintMessage")
  }, props.hintText)));
};
var InputSearch_component_default = InputSearch;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  InputSearch
});
//# sourceMappingURL=InputSearch.component.js.map